export enum SessionStatus {
  EmAndamento = 1,
  Vitoria = 2,
  Derrota = 3,
  Timeout = 4,
  Erro = 5,
}
